import type { EmblaCarouselType } from 'embla-carousel';
import type { FC } from 'react';
import { Button, Flex, Icon } from '@ui';
import { useCallback, useEffect, useState } from 'react';

type Props = {
    emblaApi: EmblaCarouselType | undefined;
};

export const CarouselButtons: FC<Props> = ({ emblaApi }) => {
    const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
    const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

    const handleSelect = useCallback((emblaApi: EmblaCarouselType) => {
        setPrevBtnDisabled(!emblaApi.canScrollPrev());
        setNextBtnDisabled(!emblaApi.canScrollNext());
    }, []);

    useEffect(() => {
        if (!emblaApi)
            return;

        handleSelect(emblaApi);
        emblaApi.on('reInit', handleSelect).on('select', handleSelect);
    }, [emblaApi, handleSelect]);

    return (
        <Flex gap={16}>
            <Button
                icon={<Icon.Arrow rotate={180} />}
                onClick={() => emblaApi?.scrollPrev()}
                disabled={prevBtnDisabled}
            />
            <Button
                icon={<Icon.Arrow />}
                onClick={() => emblaApi?.scrollNext()}
                disabled={nextBtnDisabled}
            />
        </Flex>
    );
};
